/*
 * createFilterOptions — transforms an observatory's `available_filters`
 * (array of strings: ['L','R','G','B','Ha','dark']) into the
 * { value, label, color } shape that TargetExposureConfig's Select expects.
 *
 * Extracted from ObservationSubmit so ObservationEdit (and any other
 * filter-rendering page) can use the same mapping without duplicating
 * the colorMap/labelMap.
 */

const colorMap = {
  'L': '#ffffff',
  'R': '#ff0000',
  'G': '#00ff00',
  'B': '#0000ff',
  'Ha': '#ff6b6b',
  'HA': '#ff6b6b',
  'halpha': '#ff6b6b',
  'OIII': '#4ecdc4',
  'O3': '#4ecdc4',
  'SII': '#ffe66d',
  'SI': '#ffe66d',
  'lum': '#ffffff',
  'red': '#ff0000',
  'green': '#00ff00',
  'blue': '#0000ff',
  'Clear': '#e0e0e0',
  'OPEN': '#e0e0e0',
  'Open': '#e0e0e0',
  'C': '#e0e0e0',
  'V': '#90ee90',
  'I': '#8b0000',
  'CBB': '#1e90ff',
  'SR': '#ff8888',
  'SG': '#88ff88',
  'SZ': '#cc66ff',
  'SU': '#9933ff',
  'dark': '#000000',
  'DARK': '#000000',
  'Dark': '#000000',
  'empty': '#d0d0d0',
};

const labelMap = {
  'L': 'Luminance (L)',
  'R': 'Red (R)',
  'G': 'Green (G)',
  'B': 'Blue (B)',
  'Ha': 'H-alpha (Ha)',
  'HA': 'H-alpha (HA)',
  'halpha': 'H-alpha',
  'OIII': 'Oxygen III (OIII)',
  'O3': 'Oxygen III (O3)',
  'SII': 'Sulfur II (SII)',
  'SI': 'Sulfur II (SI)',
  'lum': 'Luminance (lum)',
  'red': 'Red',
  'green': 'Green',
  'blue': 'Blue',
  'Clear': 'Clear/No Filter',
  'OPEN': 'Open',
  'Open': 'Open',
  'C': 'Clear (C)',
  'V': 'Visual (V)',
  'I': 'Infrared (I)',
  'CBB': 'Clear Blue Blocking (CBB)',
  'SR': 'Sloan r',
  'SG': 'Sloan g',
  'SZ': 'Sloan z',
  'SU': 'Sloan u',
  'dark': 'Dark (opaque)',
  'DARK': 'Dark (opaque)',
  'Dark': 'Dark (opaque)',
  'empty': 'Empty (no filter)',
};

/**
 * @param {string[]} filters - filter names from observatory.capabilities.available_filters
 * @returns {Array<{value: string, label: string, color: string}>}
 */
export function createFilterOptions(filters) {
  if (!Array.isArray(filters)) return [];
  return [...filters].sort().map((filter) => ({
    value: filter,
    label: labelMap[filter] || filter,
    color: colorMap[filter] || '#999999',
  }));
}
